import { styled, Box, BoxProps } from '@mui/material';

export const StyledFormFieldsBox = styled(Box)<BoxProps>(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(2)
}));
